import { Card as MuiCard, Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { collectionCardStyles } from './CollectionCard.styles';

export interface CollectionCardProps {
  name: string;
  description?: string;
  descriptionMaxLines?: number;
  imageUrl?: string;
  imageAlt?: string;
  showInAssignExperience?: boolean;
  showInAssignExperienceDisabled?: boolean;
  onShowInAssignExperienceChange?: (showInAssignExperience: boolean) => void;
}

export const CollectionCard = ({
  name,
  description,
  descriptionMaxLines = 3,
  imageUrl,
  imageAlt,
  showInAssignExperience,
  showInAssignExperienceDisabled = false,
  onShowInAssignExperienceChange,
}: CollectionCardProps) => {
  const theme = useTheme();
  const showAssignExperienceToggle = typeof showInAssignExperience === 'boolean' && !!onShowInAssignExperienceChange;

  const handleShowInAssignExperienceChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    event.stopPropagation();
    if (showInAssignExperienceDisabled) {
      return;
    }

    onShowInAssignExperienceChange?.(checked);
  };

  return (
    <MuiCard sx={collectionCardStyles.container(theme)}>
      {showAssignExperienceToggle && (
        <FormControlLabel
          label="Show in Assign Experience"
          labelPlacement="end"
          onClick={(event) => event.stopPropagation()}
          control={
            <Checkbox
              checked={showInAssignExperience}
              disabled={showInAssignExperienceDisabled}
              onChange={handleShowInAssignExperienceChange}
            />
          }
          sx={collectionCardStyles.assignExperienceToggle(theme)}
        />
      )}
      {imageUrl && (
        <Box sx={collectionCardStyles.imageContainer(theme)}>
          <Box
            component="img"
            src={imageUrl}
            alt={imageAlt || name}
            sx={collectionCardStyles.image(theme)}
          />
        </Box>
      )}
      <Box sx={collectionCardStyles.contentContainer(theme, showAssignExperienceToggle)}>
        <Typography sx={collectionCardStyles.title(theme)}>{name}</Typography>
        {description && (
          <Typography sx={collectionCardStyles.description(theme, descriptionMaxLines)}>
            {description}
          </Typography>
        )}
      </Box>
    </MuiCard>
  );
};

export default CollectionCard;
